import React from 'react';
import PropTypes from 'prop-types';
import style from 'screens/ContentDetail/components/Overlay/Overlay.module.scss';
import Overlay from 'screens/ContentDetail/components/Overlay';

const Modal = ({
  description,
  handleOverlayClick,
  id,
  handleCloseModal,
  modalRef,
  name,
  showModal,
}) => {
  if (!showModal) return null;
  return (
    <Overlay ref={modalRef} id={id} onClick={handleOverlayClick}>
      <div className={style.inner}>
        <div className={style.title}>{name}</div>
        <div className={style.description}>{description}</div>
        <div className={style.close} onClick={handleCloseModal} />
      </div>
    </Overlay>
  );
};

Modal.propTypes = {
  description: PropTypes.string,
  handleCloseModal: PropTypes.func,
  handleOverlayClick: PropTypes.func,
  id: PropTypes.string,
  modalRef: PropTypes.shape({}),
  name: PropTypes.string,
  showModal: PropTypes.bool,
};
export default Modal;
